export const getRandomInt = () => {
    return -Math.floor(Math.random() * 1000000)
}

export const isDev = (callback) => {
    if (process.env.NODE_ENV === "development") {
        callback && callback()
    }
}

export const checkErrResponse = (res) => {
    if (res.code === -1) {
        return true
    }
    return false
}
